import type { RuntimeHelpLinks } from "../config";

// Ratified: docs/open-questions.md#security-support-contacts
export const SUPPORT_EMAIL = "support@usemarker.ai";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export function documentationHref(
  helpLinks: RuntimeHelpLinks,
): string | undefined {
  const href = helpLinks.documentationUrl?.trim();
  return href && href.length > 0 ? href : undefined;
}
